import BaseCommand from "@/models/api/commands/BaseCommand";

export class RemoveItemCommand extends BaseCommand {
  CommandName = "RemoveItem";
  Command: { TmpId: string };
  constructor(sessionId: string, operationId: string, tmpId: string) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId };
  }
}
